import { render, staticRenderFns } from "./dailyQuizzes.vue?vue&type=template&id=e234fdb4&scoped=true"
import script from "./dailyQuizzes.vue?vue&type=script&lang=js"
export * from "./dailyQuizzes.vue?vue&type=script&lang=js"
import style0 from "./dailyQuizzes.vue?vue&type=style&index=0&id=e234fdb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e234fdb4",
  null
  
)

export default component.exports